import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PrivacyPolicyComponent } from '../privacy-policy/privacy-policy.component';

@Component({
  selector: 'terms-of-use',
  templateUrl: './terms-of-use.component.html',
  styleUrls: ['./terms-of-use.component.scss']
})
export class TermsOfUseComponent implements OnInit {
  modalConfig = {
    ignoreBackdropClick: true,
    class: 'modal-sm'
  };

  constructor(
    private modalRef: BsModalRef,
    private modalService: BsModalService
  ) {}

  ngOnInit() {}

  showPrivacyPolicyModal() {
    this.modalRef.hide();
    this.modalConfig.ignoreBackdropClick = false;
    this.modalConfig.class = 'modal-lg';
    this.modalRef = this.modalService.show(
      PrivacyPolicyComponent,
      this.modalConfig
    );
  }

  close() {
    this.modalRef.hide();
  }
}
